import Phase1HistoryEditorPage from "./page";
export default Phase1HistoryEditorPage;